import React from 'react'
import { Box, Paper, Typography } from '@material-ui/core'

export interface RuleParamsPanelProps {
	children: React.ReactNode
}

export function RuleParamsPanel({ children }: RuleParamsPanelProps) {
	return (
		<Paper
			variant="outlined"
			style={{ borderRadius: 10, marginBottom: 10, overflow: 'hidden' }}
		>
			<Box
				style={{
					padding: '11px 16px',
					background: '#fafafa',
					borderBottom: '1px solid rgba(0,0,0,0.08)',
				}}
			>
				<Typography variant="body2" style={{ fontWeight: 500, color: '#424242' }}>
					Paramètres de la règle
				</Typography>
			</Box>
			{children}
		</Paper>
	)
}
